import * as React from 'react';

import { LOOKUP_MODULE_NAME } from '../../LookupTable';

import './Image.styles.scss';

export const Image = ({ id, index }) => {
  return (
    <div id={`${LOOKUP_MODULE_NAME}-image--id-${id}--index-${index}`}>
      Image field
    </div>
  );
};